import React from 'react';
import styles from './group-text.scss';

export const GroupText: React.FC<React.PropsWithChildren> = ({ children }) => <span className={styles.text}>{children }</span>;
